export default __webpack_public_path__ + "alberta-lens.6ec4ae8d4f0ac094867a.svg";